import React, { useEffect, useState } from 'react';
import { motion, useScroll, AnimatePresence } from 'framer-motion';
import { MenuIcon, X as CloseIcon } from 'lucide-react';
export const SubjectivitiesNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const {
    scrollY
  } = useScroll();
  // Update navbar appearance based on scroll position
  useEffect(() => {
    const updateScrollState = () => {
      setHasScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', updateScrollState);
    updateScrollState(); // Initial check
    return () => window.removeEventListener('scroll', updateScrollState);
  }, []);
  // Simplified menu items without Products dropdown
  const menuItems = [{
    label: 'How It Works',
    url: '#customer-value'
  }, {
    label: 'Integrations',
    url: '#integrations'
  }, {
    label: 'Security',
    url: '#security'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${hasScrolled ? 'bg-white shadow-[0_4px_30px_rgba(46,107,255,0.08)] border-b border-[#E7EAF0]/40' : 'bg-white border-b border-[#E7EAF0]/20'}`} data-id="element-877">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-878">
        <div className="flex justify-between items-center h-16" data-id="element-879">
          {/* Logo and Navigation */}
          <div className="flex items-center" data-id="element-880">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5
          }} className="flex-shrink-0" data-id="element-881">
              <a href="/" className="flex items-center" data-id="element-882">
                <img src="https://i.imgur.com/W2X0iTc.png" alt="Pigeon Logo" className="h-10 mr-2" data-id="element-883" />
                <span className="text-xl font-bold flex flex-col -space-y-2" style={{
                fontFamily: 'Helvetica, sans-serif'
              }} data-id="element-884">
                  <span style={{
                  color: '#1432f4'
                }} data-id="element-885">
                    Pigeon
                  </span>
                  <span style={{
                  color: '#000000'
                }} data-id="element-886">
                    Subjectivities
                  </span>
                </span>
              </a>
            </motion.div>
            <div className="hidden md:block ml-6" data-id="element-887">
              <div className="flex items-center space-x-4" data-id="element-888">
                {menuItems.map((item, index) => <div key={index} className="relative group" data-id="element-889">
                    <motion.button className="text-[#5A6376] hover:text-[#0B1220] px-2 py-1.5 rounded-md text-sm font-medium flex items-center whitespace-nowrap" whileHover={{
                  y: -1
                }} transition={{
                  type: 'spring',
                  stiffness: 300
                }} data-id="element-890">
                      <a href={item.url} data-id="element-891">{item.label}</a>
                    </motion.button>
                  </div>)}
              </div>
            </div>
          </div>
          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-3" data-id="element-892">
            <motion.a href="https://app.pigeondocuments.com/login" className="text-[#5A6376] hover:text-[#0B1220] px-2 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap" whileHover={{
            y: -1
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} data-id="element-893">
              Log In
            </motion.a>
            <motion.a href="https://calendly.com/pigeondocuments" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#2E6BFF] to-[#36D1DC] hover:from-[#2059E2] hover:to-[#32C3CE] text-white px-6 py-3 rounded-full text-base font-medium transition-all duration-300 shadow-[0_4px_14px_rgba(46,107,255,0.25)] whitespace-nowrap" whileHover={{
            y: -1,
            scale: 1.02,
            boxShadow: '0 6px 20px rgba(46,107,255,0.35)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-894">
              Book a Call
            </motion.a>
          </div>
          {/* Mobile CTA and Menu Button */}
          <div className="md:hidden flex items-center space-x-2" data-id="element-895">
            <motion.a href="https://calendly.com/pigeondocuments" target="_blank" rel="noopener noreferrer" className="bg-gradient-to-r from-[#2E6BFF] to-[#36D1DC] hover:from-[#2059E2] hover:to-[#32C3CE] text-white px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-300 shadow-[0_4px_14px_rgba(46,107,255,0.25)] whitespace-nowrap" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-896">
              Book a Call
            </motion.a>
            <motion.button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-[#5A6376] hover:text-[#0B1220] focus:outline-none" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} aria-expanded={isMenuOpen} aria-label="Toggle menu" data-id="element-897">
              {isMenuOpen ? <CloseIcon className="h-6 w-6" data-id="element-898" /> : <MenuIcon className="h-6 w-6" data-id="element-899" />}
            </motion.button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="md:hidden bg-white border-b border-[#E7EAF0]/40 shadow-lg" data-id="element-900">
          <div className="px-4 pt-2 pb-4 space-y-1" data-id="element-901">
            {menuItems.map((item, index) => <div key={index} className="py-1" data-id="element-902">
                <motion.a href={item.url} className="text-[#0B1220] block px-3 py-2.5 rounded-md text-base font-medium w-full text-left" whileHover={{
            y: -2,
            backgroundColor: '#F0F5FF'
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} data-id="element-903">
                  {item.label}
                </motion.a>
              </div>)}
            <div className="pt-2 mt-2 border-t border-[#E7EAF0]" data-id="element-904">
              <motion.a href="https://app.pigeondocuments.com/login" className="text-[#0B1220] block px-3 py-2.5 rounded-md text-base font-medium" whileHover={{
            x: 2,
            backgroundColor: '#F0F5FF'
          }} transition={{
            type: 'spring',
            stiffness: 300
          }} data-id="element-905">
                Log In
              </motion.a>
            </div>
          </div>
        </motion.div>}
    </nav>;
};